module.exports = __webpack_public_path__ + "static/media/planning-for-success@2x.b54820b9.png";